import React from 'react';
import styles from './game-block.module.scss';

const PlayButton = ({onClick}) => {
  return (
    <div className={styles.playButton} onClick={onClick}>
      <svg width="107" height="110" viewBox="0 0 107 110" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_1_370)">
          <path fillRule="evenodd" clipRule="evenodd" d="M67.8878 93.9005C56.8625 96.7793 45.7817 93.4418 36.0131 87.5643C24.9438 80.9041 13.2189 72.8226 11.5556 60.0064C9.78676 46.3777 17.7734 33.7381 27.8108 24.3647C38.1612 14.6991 51.7355 6.07807 65.4273 9.69883C78.3673 13.1208 82.7121 28.1299 88.218 40.3393C92.9212 50.7684 97.8026 61.7977 93.744 72.4904C89.5644 83.5018 79.2772 90.9267 67.8878 93.9005Z" fill="#E90909"/>
        </g>
        <g filter="url(#filter1_d_1_370)">
          <path d="M66.7617 47.8101C69.1813 49.4247 69.413 52.8791 67.1978 54.7645C60.2743 60.6575 54.2584 64.5668 45.9784 67.6529C43.4975 68.5775 40.8412 67.0102 40.3847 64.4022C39.8288 61.2267 39.2182 57.0771 39.1481 53.8489C39.0576 49.6807 39.8063 44.1957 40.4489 40.3341C40.8765 37.7648 43.4358 36.2035 45.9099 37.0176C49.2612 38.1204 53.7563 39.7724 56.9406 41.6021C59.9527 43.3328 63.7887 45.8261 66.7617 47.8101Z" fill="white"/>
        </g>
        <defs>
          <filter id="filter0_d_1_370" x="0.104867" y="0.922537" width="106.356" height="108.504" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dy="3.27116"/>
            <feGaussianBlur stdDeviation="5.60186"/>
            <feComposite in2="hardAlpha" operator="out"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0.792157 0 0 0 0 0.0745098 0 0 0 0 0.0745098 0 0 0 0.69 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_370"/>
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_370" result="shape"/>
          </filter>
          <filter id="filter1_d_1_370" x="39.1406" y="36.8009" width="29.5859" height="32.4123" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dy="1.29289"/>
            <feComposite in2="hardAlpha" operator="out"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_370"/>
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_370" result="shape"/>
          </filter>
        </defs>
      </svg>
    </div>
  );
};

export default PlayButton;